import React, {Component} from "react";
import './index.css'
import PropTypes from "prop-types";
import {Var} from "../../../App";

class ValidationSpot extends Component {
    constructor(props) {
        super(props);

        this.state = {
            disabled: false,
            readOnly: false,
            error: null,
            id: `inp_${Var.shuffle('string', 6)}`
        };

        this.ref = {
            spot: React.createRef()
        }
    }

    static defaultProps = {
        readOnly: false,
        disabled: false,
        label: null,
        validation: _ => null
    };

    static propTypes = {
        readOnly: PropTypes.bool,
        disabled: PropTypes.bool,
        label: PropTypes.string,
        validation: PropTypes.func
    };

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return this.props !== nextProps ||
            this.state.readOnly !== nextState.readOnly ||
            this.state.disabled !== nextState.disabled ||
            this.state.error !== nextState.error;
    }

    render() {
        const {state} = this;
        const props = {...this.props};
        const readOnly = state.readOnly || props.readOnly;
        const disabled = state.disabled || props.disabled;
        props.className += ` ValidationSpot ${!readOnly && !disabled && state.error ? 'error' : ''}`;
        delete props.validation;

        props.readOnly && (props.className += ' read-only');
        props.disabled && (props.className += ' disabled');

        return (<div ref={this.ref.spot} {...props}>
            {props.children}
            {state.error && <p className={'ValidationSpot-error'}>{state.error}</p>}
        </div>);
    }

    error(prompt = false) {
        this.setState({error: prompt});
    }

    validate(value) {
        const {props} = this;
        const validate = props.validation(value);

        if (validate === true)
            this.error();
        else
            this.error(validate);

        return validate === true ? true : {
            label: props.label || '',
            message: validate
        };
    }
}

export default ValidationSpot